export const analyticsCustomEventName = {
  validationError: 'BrightTagPageEvents.ValidationError',
  serviceError: 'BrightTagPageEvents.ServiceError',
  jbAnalyticsEvent: 'JBAnalyticsEvent',
};
